import React from "react";
import ReactDOM from "react-dom";
// import authLink from './utils/authLink';
import App from "./App";
import "./index.css";

// console.log(utils);

// const httpLink = createHttpLink({
//   uri: utils.graphqlPath,
// });

ReactDOM.render(<App />, document.getElementById("root"));
